var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

// テスト
var _isTest = false;

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

$(window).on('resize load' , function() {
  if(windowW <= 1024){
    _isSP = true;
  } else {
    _isSP = false;
  };

  //リサイズ処理 ブレイクポイントを跨いだらリロード
  var nowWidth = window.innerWidth;
  if(prewidth !== nowWidth){
    if(prewidth < 1025) {
      if(nowWidth >= 1025){
        location.reload();
      }
    }else {
      if(nowWidth < 1025){
        location.reload();
      }
    }
  };
});

$(window).on('load' , function() {
  //アニメーション省略
  if(_isTest) {
  }else {
  }

  setTimeout(function(){$('.sw-Loading').addClass("load");},0);
  setTimeout(function(){$('.sw-Loading').remove();},1300);
  setTimeout(function(){$('.sw-Ttl').addClass("is-animated");},300);
  setTimeout(function(){$('.sw-Lower_Contents').addClass("is-animated");},300);

  bgStar();
  scrollCommonAnime();

});


// ------------------------------------------------------------------------
// bgStar
// ----- BOTH
// ------------------------------------------------------------------------
const bgStar = () => {
  particlesJS("bg_Star", {"particles":{"number":{"value":20,"density":{"enable":true,"value_area":800}},"color":{"value":"#003555"},"shape":{"type":"circle","stroke":{"width":0,"color":"#000000"},"polygon":{"nb_sides":5},"image":{"src":"img/github.svg","width":100,"height":100}},"opacity":{"value":0.2,"random":true,"anim":{"enable":true,"speed":.5,"opacity_min":0,"sync":false}},"size":{"value":2.5,"random":true,"anim":{"enable":false,"speed":40,"size_min":10,"sync":true}},"line_linked":{"enable":false,"distance":150,"color":"#ffffff","opacity":0.2,"width":1},"move":{"enable":true,"speed":0.1,"direction":"none","random":true,"straight":false,"out_mode":"bounce","bounce":false,"attract":{"enable":false,"rotateX":600,"rotateY":600}}},"interactivity":{"detect_on":"canvas","events":{"onhover":{"enable":false,"mode":"repulse"},"onclick":{"enable":false,"mode":"repulse"},"resize":true},"modes":{"grab":{"distance":400,"line_linked":{"opacity":1}},"bubble":{"distance":250,"size":0,"duration":2,"opacity":0,"speed":3},"repulse":{"distance":400,"duration":0.4},"push":{"particles_nb":4},"remove":{"particles_nb":2}}},"retina_detect":true});
};

// ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  let endHeight = document.querySelector('.st-Container').offsetHeight

  // ページトップ
  gsap.to('.st-Container', {
    scrollTrigger: {
      trigger: '.st-Container',
      start: '+=80px top',
      end: 'bottom top',
      toggleClass: { targets: "#st-Top", className: "st-Top-Show" },
    }
  });

  // ヘッダーロゴ
  gsap.to('.st-Container', {
    scrollTrigger: {
      trigger: '.st-Container',
      start: '+=120px top',
      end: 'bottom top',
      toggleClass: { targets: "#st-Header", className: "st-Header-Shorten" },
    }
  });

  if(!_isSP) {
    // 星背景
    gsap.to('.st-Bg-shooting_star-l', {
      // onStart:myFunc,
      backgroundPosition: "-20000px 8000px",
      scrollTrigger: {
        trigger: '.st-Container',
        start: 'top top',
        end: '+=55999px top',
        // end: () => '+=' + endHeight,
        // end: '+=120px top',
        // end:,
        scrub: true,　//スクロールバーに直接リンクさせて動作させる
        // markers: true // 検証用のマーカーを表示
      }
    });

    // 星背景
    gsap.to('.st-Bg-shooting_star-r', {
      backgroundPosition: "-20000px 8000px",
      scrollTrigger: {
        trigger: '.st-Container',
        start: 'top top',
        end: '+=55999px top',
        scrub: true,
        // markers: true // 検証用のマーカーを表示
      }
    });
    // function myFunc(){
    //   console.log( "finished" );
    // }
  } else {
    // // 星背景
    // gsap.to('.st-Bg-shooting_star-l', {
    //   // onStart:myFunc,
    //   backgroundPosition: "-10000px 4000px",
    //   scrollTrigger: {
    //     trigger: '.st-Container',
    //     start: 'top top',
    //     end: '+=55999px top',
    //     // end: () => '+=' + endHeight,
    //     // end: '+=120px top',
    //     // end:,
    //     scrub: true,　//スクロールバーに直接リンクさせて動作させる
    //     // markers: true // 検証用のマーカーを表示
    //   }
    // });

    // // 星背景
    // gsap.to('.st-Bg-shooting_star-r', {
    //   backgroundPosition: "-10000px 4000px",
    //   scrollTrigger: {
    //     trigger: '.st-Container',
    //     start: 'top top',
    //     end: '+=55999px top',
    //     scrub: true,
    //     // markers: true // 検証用のマーカーを表示
    //   }
    // });
  }

  // const controller = new ScrollMagic.Controller();

  // //ページトップ出現
  // const scene = new ScrollMagic.Scene({
  //   // triggerElement:'#index-Contents',
  //   triggerHook: 1,
  //   offset: '80'
  // })
  // .setClassToggle('#st-Top', 'st-Top-Show')
  // .addTo(controller);

  // //ヘッダー
  // new ScrollMagic.Scene({
  //   triggerHook: 1,
  //   offset: '80'
  // })
  // .setClassToggle("#st-Header", "st-Header-Shorten")
  // .addTo(controller);


  // //背景
  // new ScrollMagic.Scene({
  //   triggerElement: '.st-Container',
  //   triggerHook: 1,
  //   duration: $('.st-Container').innerHeight(),
  //         // duration: "200%"
  // })
  // .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
  //   var p = prog.progress; // 0～1の値が入ってきます
  //   anime({
  //     targets:".st-Bg-shooting_star-l",
  //     backgroundPositionY: (8 * p) * 100 + "px",
  //     backgroundPositionX: -(20 * p) * 100 + "px",
  //     easing: 'easeOutCubic',
  //     duration: 10,
  //     elasticity: 0
  //   });
  //   anime({
  //     targets:".st-Bg-shooting_star-r",
  //     backgroundPositionY: (8 * p) * 100 + "px",
  //     backgroundPositionX: -(20 * p) * 100 + "px",
  //     easing: 'easeOutCubic',
  //     duration: 10,
  //     elasticity: 0
  //   });
  // })
  // // .addIndicators({name: "1"})
  // .addTo(controller);

  // //　スクロールで発火系
  // const targets = document.querySelectorAll(".js-scrollAnimation");
  // const targetsArray = Array.prototype.slice.call(targets); //Array
  // targetsArray.forEach(target => {
  //   //シーンを作成
  //   new ScrollMagic.Scene({
  //       triggerElement: target,
  //       triggerHook: 1
  //   })
  //   .setClassToggle(target, "is-animated")
  //   .addTo(controller);
  // });

};



// WEBPACK FOOTER //
// ./src/movie-argo_v1/assets/js/common/script.js